import { AutogenModelEdiChangeField, AutogenRowEdiChangeField } from "./autogen/AutogenModelEdiChangeField";

export class ModelEdiChangeField extends AutogenModelEdiChangeField<RowEdiChangeField> {
	constructor() {
		super(RowEdiChangeField);
	}
}

export class RowEdiChangeField extends AutogenRowEdiChangeField {
}